// Documentation: https://github.com/ankane/ahoy.js

import ahoy from "ahoy.js";
import { authenticatedHeadersHash } from "./authentication";

// This module is evaluated at bundle load on every page, so a missing anon_token cookie
// (possible on V1-hosted pages) must not throw here and kill every script that evaluates
// after this one.
let headers;
try {
  headers = authenticatedHeadersHash();
} catch {
  headers = null;
}

// https://github.com/ankane/ahoy.js/#configuration
ahoy.configure({
  cookieDomain: globalThis?.Qwoted?.ETLD_PLUS_ONE,
  cookies: true,
  eventsUrl: "/account/api/ahoy/events",
  headers: headers || {},
  page: null,
  platform: "Web",
  // Without headers ahoy must never become ready: readiness also flushes events replayed
  // from its own ahoy_events cookie, which would bypass the track no-op below.
  startOnReady: Boolean(headers),
  trackVisits: false,
  urlPrefix: "",
  useBeacon: true,
  // visitDuration: 4 * 60, // 4 hours
  visitParams: {},
  // visitorDuration: 2 * 365 * 24 * 60 // 2 years
  visitsUrl: "/account/api/ahoy/visits",
  withCredentials: true, // TODO
});

if (globalThis?.Qwoted?.BUSINESS_ENVIRONMENT !== "production") {
  ahoy.debug();
}

const qahoy = ahoy;

// The ahoy endpoints reject any request without the apikey token (401), so when the cookie is
// absent swallow events client-side instead of emitting guaranteed-failing requests.
if (!headers) {
  qahoy.track = () => {};
}

window.qahoy = qahoy;

export default qahoy;
